// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>
import Rails from "@rails/ujs";
import * as Turbo from "@hotwired/turbo";
import * as ActiveStorage from "@rails/activestorage";

import "~/controllers";
import "~/helpers/sweetalert";
import "~/helpers/trix_customization";

import flatpickr from "flatpickr";
import $ from "jquery";
import select2 from "select2";
select2($);

import "trix";
import "@rails/actiontext";

import "~/stylesheets/tailwind.css";

if (!window._rails_loaded) Rails.start();

import "chartkick/chart.js";

ActiveStorage.start();

// Destroy javascript generated html, so turbo won't cache it
document.addEventListener("turbo:before-cache", function () {
  $(".js-select2").select2("destroy");
});

document.addEventListener("turbo:load", () => {
  $(document).on("select2:open", () => {
    document.querySelector(".select2-search__field").focus();
  });
  $(".js-select2").select2();

  document.querySelectorAll(".js-toggle").forEach((element) => {
    if (element.value == 1) {
      element.closest("label").classList.toggle("bg-blue-500");
      element
        .closest("label")
        .querySelector(".js-toggle--transistion")
        .classList.toggle("-translate-x-5");
    }

    element.addEventListener("click", function () {
      this.closest("label").classList.toggle("bg-blue-500");
      this.closest("label")
        .querySelector(".js-toggle--transistion")
        .classList.toggle("-translate-x-5");
    });
  });

  flatpickr(".js-flatpickr", {
    dateFormat: "Y-m-d",
  });
});

document.addEventListener("turbo:before-fetch-request", (event) => {
  // Turbo Drive does not send a referrer like turbolinks used to, so let's simulate it here
  event.detail.fetchOptions.headers["Turbo-Referrer"] = window.location.href;
  event.detail.fetchOptions.headers["X-Turbo-Nonce"] = document
    .querySelector("meta[name='csp-nonce']")
    .getAttribute("content");
});

document.addEventListener("turbo:before-cache", function () {
  const scriptTagsToAddNonces = document.querySelectorAll("script[nonce]");
  scriptTagsToAddNonces.forEach((element) => {
    element.setAttribute("nonce", element.nonce);
  });
});

document.addEventListener("turbo:load", function () {
  const openModalButton = document.getElementById("open-modal");
  const modal = document.getElementById("committee-members-modal");
  const form = document.querySelector("form");

  openModalButton.addEventListener("click", function (event) {
    event.preventDefault();
    modal.classList.remove("hidden");
  });

  modal.addEventListener("click", function (event) {
    if (event.target === modal) {
      modal.classList.add("hidden");
    }
  });

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    const formData = new FormData(form);
    const data = {};
    formData.forEach((value, key) => {
      data[key] = value;
    });
    form.submit();
  });
});

document.addEventListener("turbo:load", function () {
  document.body.addEventListener("click", function (event) {
    const button = event.target.closest(".reply-button");
    if (button) {
      const commentId = button.dataset.commentId;
      const replyFormContainer = document.getElementById(`reply-form-${commentId}`);

      if (replyFormContainer) {
        document.querySelectorAll(".reply-form-container").forEach((container) => {
          if (container !== replyFormContainer) {
            container.style.display = "none";
          }
        });

        replyFormContainer.style.display =
          replyFormContainer.style.display === "none" ? "block" : "none";
      }
    }
  });
});
